export default function ScheduledPostIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7Z"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <path
          d="M3.5 7C3.5 8.933 5.067 10.5 7 10.5V3.5C5.067 3.5 3.5 5.067 3.5 7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
